export const errorHandler = (errorsObj, translate) => {
  let translatedErrors = {};
  const errorsObjKeys = Object.keys(errorsObj);
  errorsObjKeys.map(
    (key) => (translatedErrors[key] = translate(errorsObj[key].replace(/ /g, '_')))
  );

  return translatedErrors;
};
